import {useRef} from 'react';

import {useRampFlagShadowBRSDQQuery} from '../../../util/rampFeatureFlags';

/**
 * The idea here is that we want to be able to slide the shadowing rate up and down for full fidelity queries WITHOUT hammering the backend. Because we can't directly return a percentage rate from a ramp flag (only a true/false) I'm combining a hardcoded sample rate with a user rate. This way I can scale usage by % users allowed * throttle rate, which would maximally allow 5% of queries to shadow but can be throttled much lower by ramping down the user ramp flag and won't ever create a single user who is hammering the backend because all of their queries are being shadowed.
 *
 * Additionally, I'm only going to shadow the initial query so that we don't continue to shadow as a user uses a workspace.
 */
export const useShadowFullFidelity = (
  throttleRate: number = 5, // percentage of times that we'll allow an allowed user to shadow
  value: number = Math.random() * 100 // the number to compare against the throttle rate
) => {
  const isShadowBRSDQQueryEnabled = useRampFlagShadowBRSDQQuery();

  // we only want to calculate this once per panel so that the "will i or will i not shadow" question is asked
  // oncer per panel (on mount) and globally for the workspace or multiple times over the panel's lifecycle
  const canShadow = useRef(value <= throttleRate);
  return canShadow.current && isShadowBRSDQQueryEnabled;
};
